import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const offline: ThemeUICSSObject = {
  /* PREPEND HERE */
  upsertion: {
    '.gridContainer': {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      'table:first-of-type ': {
        tr: {
          display: 'flex',
          flexDirection: 'row',
          gap: '5px',
        },
        'td:nth-of-type(2)': {
          pr: '20px',
        },
      },
    },

    br: {
      display: 'none',
    },
    '.fieldGroup': {
      pb: '5px',
    },
  },
};

export default offline;
